/**
 * Resize done event
 *
 * Publishes a 'resizeDone' event triggered when window resizing is complete.
 * Components can subscribe to it to update their state.
 * Also sets a --windowHeight css variable for use in CSS, instead of 100vh
 */

class Viewport {

    constructor() {

        // SSR support
        if (typeof window === 'undefined') {
            return;
        }

        // measure viewport
        this.measureViewport();

        // measure scrolbar width
        this.measureScrollbar();

        // resizeDone event is only triggered when window width resizes,
        // not when scrolling down on mobile, where the viewport height changes.
        let windowWidth = window.innerWidth;
        const event = new Event("resizeDone");

        window.addEventListener("resize", this.debounce(e => {
            let currentWindowWidth = window.innerWidth;
            if (currentWindowWidth !== windowWidth) {

                // re-measure viweport
                this.measureViewport();

                // let components subscribe to the event
                window.dispatchEvent(event);

                // update for next time
                windowWidth = currentWindowWidth;
            }
        }));
    }

    measureScrollbar()  {
        // scrollbar width (will be 0 if system is using overlay scrollbars)
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbarWidth', (scrollbarWidth + "px"));
    }

    measureViewport() {

        if ('CSS' in window &&
            'supports' in window.CSS &&
            window.CSS.supports('height: 100svh') &&
            window.CSS.supports('height: 100dvh') &&
            window.CSS.supports('height: 100lvh')
        ) {
            // Native support for svh, dvh and lvh units
            document.documentElement.style.setProperty('--svh', "1svh");
            document.documentElement.style.setProperty('--dvh', "1dvh");
            document.documentElement.style.setProperty('--lvh', "1lvh");
        } else {
            // Polyfill

            // div to measure vh
            this.measureVh = document.getElementById('measure-vh');

            // smallest viewport height
            let svh = document.documentElement.clientHeight * 0.01;
            document.documentElement.style.setProperty('--svh', (svh + "px"));

            // dynamic viewport height
            let dvh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--dvh', (dvh + "px"));

            // largest possible viewport height (behaves the same as 1vh)
            let fixedHeight = this.measureVh.clientHeight;
            let lvh = fixedHeight * 0.01;
            document.documentElement.style.setProperty('--lvh', (lvh + "px"));
        }

        // is mobile?
        if ( window.innerWidth < 768) {
            document.body.classList.add('is-mobile');
        } else {
            document.body.classList.remove('is-mobile');
        }
    }

    debounce = (fn, time) => {
        time = time || 100; // 100 by default if no param
        let timer;
        return function(event){
            if (timer) clearTimeout(timer);
            timer = setTimeout(fn, time, event);
        };
    }
}

export default Viewport;